/*
 * Focus chip rendered above the agent composer when the user has just
 * clicked a block affordance (e.g. "Ask chord advisor"). One-shot:
 * consumed on submit or dismissed via the × button.
 */
.focusChip {
  display: inline-flex;
  align-items: center;
  gap: var(--tuna-spacing-0_5, 4px);
  padding: 2px 8px;
  margin: 4px 0;
  background: var(--tuna-surface-elevated, var(--tuna-palette-background-paper));
  border: 1px solid var(--tuna-palette-divider, rgba(0, 0, 0, 0.12));
  border-radius: 999px;
  font-size: 12px;
  line-height: 1.4;
  color: var(--tuna-content-secondary);
}

.focusChip button {
  background: none;
  border: 0;
  padding: 0 2px;
  cursor: pointer;
  color: inherit;
  font-size: 14px;
  line-height: 1;
}

.focusChip button:hover,
.focusChip button:focus-visible {
  color: var(--tuna-content-primary);
}

.focusChip button:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}
